import styled from '@emotion/styled';

export const MainBlock = styled.div`
  /* Page wrapper specific tweaks */
  & > .container {
    /* ensure inner containers don't overflow */
    max-width: 100%;
  }

  /* Top header container (title, buttons, balance) */
  & > .container:first-of-type {
    /* keep default desktop layout */
  }

  @media (max-width: 768px) {
    & > .container:first-of-type {
      flex-direction: column !important;
      align-items: stretch !important;
      justify-content: flex-start !important;
      gap: 12px;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    /* Left group with title and buttons */
    & > .container:first-of-type > .flex.items-center.gap-6 {
      flex-wrap: wrap;
      gap: 8px 8px !important;
    }

    /* Balance block on the right should go below and stretch */
    & > .container:first-of-type > .flex.items-center {
      width: 100%;
      justify-content: flex-start !important;
    }

    /* Horizontal divider container */
    & > .container.border-b {
      margin-top: 0;
    }

    /* Content container padding */
    & > .container.py-6 {
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
  }
`;

export const Header = styled.div``;
